import { Typography } from '@material-ui/core'
import moment from 'moment'

import { getTranslate } from '../../localization'
import { InventoryLayerValue } from '../../types/inventoryHealth'
import { formatRate } from './comparisonDate'

/**
 * One layer's holding.
 *
 * The three states are deliberately distinct, because conflating them is what
 * makes a diagnostic screen lie:
 *
 *   absent            the layer holds no document here
 *   present, no rate  it holds a document that nothing priced
 *   present, rate     it holds a price, shown with its age
 *
 * Shared by the desktop row and the mobile card. Duplicating layout across
 * breakpoints is expected (§2 Responsive); duplicating this reading of the
 * three states is not — twin branches that must stay in step are where the
 * copy-paste defects live.
 */
export default function LayerValue({ value }: { value: InventoryLayerValue }) {
  if (!value.present) {
    return (
      <Typography variant="body2" color="textSecondary">
        {getTranslate('absent')}
      </Typography>
    )
  }

  const age =
    value.changedAt != null
      ? moment(value.changedAt).fromNow()
      : getTranslate('no change time')

  return (
    <>
      {/*
        A real price and "no rate" must not look alike. Both are Present, so the
        operator would otherwise tell them apart by reading rather than by
        scanning — on a screen whose whole premise is scanning a grid.
      */}
      {value.rate != null ? (
        <Typography variant="body2">{formatRate(value.rate)}</Typography>
      ) : (
        <Typography variant="body2" color="textSecondary">
          <em>{getTranslate('no rate')}</em>
        </Typography>
      )}
      <Typography variant="caption" color="textSecondary">
        {value.allocation != null
          ? getTranslate('{n} rooms', { n: value.allocation })
          : getTranslate('no allocation')}
        {' · '}
        {age}
      </Typography>
    </>
  )
}
